var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.keycloakReady)?_c('div',[(_vm.authenticated)?_c('v-btn',{attrs:{"dark":"","outlined":""},on:{"click":_vm.logout}},[_c('span',[_vm._v("Logout")])]):(_vm.hasLogin)?_c('v-btn',{attrs:{"dark":"","outlined":""},on:{"click":_vm.login}},[_c('span',[_vm._v("Login")])]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }